import { rolesMapping } from './Config';
const screens = {
    user: {
        id: 'user',
        title: 'Users',
        type: 'item',
        url: '/app/user',
        icon: 'feather icon-users'
    },
    dashboard: {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'item',
        url: '/app/dashboard',
        icon: 'feather icon-codepen'
    },
    order: {
        id: 'order',
        title: 'Orders',
        type: 'item',
        url: '/app/order',
        icon: 'feather icon-shopping-cart'
    },
    coupons: {
        id: 'coupons',
        title: 'Coupons',
        type: 'item',
        url: '/app/coupons',
        icon: 'feather icon-bookmark'
    },
    transaction: {
        id: 'transaction',
        title: 'Transaction',
        type: 'item',
        url: '/app/transaction',
        icon: 'feather icon-credit-card'
    },
    messages: {
        id: 'messages',
        title: 'Notifications',
        type: 'item',
        url: '/app/messages',
        icon: 'feather icon-message-square'
    },
    termsAndConditions: {
        id: 'termsAndConditions',
        title: 'Terms And Conditions',
        type: 'item',
        url: '/app/termsAndConditions',
        icon: 'feather icon-message-square'
    },
    privacyPolicy: {
        id: 'privacyPolicy',
        title: 'Privacy Policy',
        type: 'item',
        url: '/app/privacyPolicy',
        icon: 'feather icon-message-square'
    }
    // report: {
    //     id: 'report',
    //     title: 'Client Report',
    //     type: 'item',
    //     url: '/app/report',
    //     icon: 'feather icon-file'
    // },
    // errorReport: {
    //     id: 'errorReport',
    //     title: 'Error Report',
    //     type: 'item',
    //     url: '/app/errorReport',
    //     icon: 'feather icon-file'
    // },
    // users: {
    //     id: 'users',
    //     title: 'Users',
    //     type: 'item',
    //     url: '/app/users',
    //     icon: 'feather icon-users'
    // },
    // project: {
    //     id: 'project',
    //     title: 'Project',
    //     type: 'item',
    //     url: '/app/project',
    //     icon: 'feather icon-folder'
    // },
    // shops: {
    //     id: 'shops',
    //     title: 'Shops',
    //     type: 'item',
    //     url: '/app/shop',
    //     icon: 'feather icon-shopping-cart'
    // },
    // period: {
    //     id: 'period',
    //     title: 'Period',
    //     type: 'item',
    //     url: '/app/period',
    //     icon: 'feather icon-clock'
    // },
    // task: {
    //     id: 'task',
    //     title: 'Task',
    //     type: 'item',
    //     url: '/app/task',
    //     icon: 'feather icon-edit'
    // },
    // evaluation: {
    //     id: 'evaluation',
    //     title: 'Evaluation',
    //     type: 'item',
    //     url: '/app/audit',
    //     icon: 'feather icon-home'
    // },
    // productivityReports: {
    //     id: 'productivityReports',
    //     title: 'Productivity Reports',
    //     type: 'item',
    //     url: '/app/productivityReports',
    //     icon: 'feather icon-file'
    // },
    // mapQuestions: {
    //     id: 'mapQuestions',
    //     title: 'Report Available Question',
    //     type: 'item',
    //     url: '/app/mapQuestions',
    //     icon: 'feather icon-file'
    // },
    // routes: {
    //     id: 'routes',
    //     title: 'Routes',
    //     type: 'item',
    //     url: '/app/routes',
    //     icon: 'feather icon-map-pin'
    // },
    // shopFiles: {
    //     id: 'shopFiles',
    //     title: 'Shop Upload',
    //     type: 'item',
    //     url: '/app/shopFiles',
    //     icon: 'feather icon-file'
    // },
    // copyPeriod: {
    //     id: 'copyPeriod',
    //     title: 'Reload Period',
    //     type: 'item',
    //     url: '/app/copyPeriod',
    //     icon: 'feather icon-refresh-cw'
    // },
    // projectWithQuestionId: {
    //     id: 'projectWithQuestionId',
    //     title: 'Flat Questions',
    //     type: 'item',
    //     url: '/app/projectWithQuestionId',
    //     icon: 'feather icon-refresh-cw'
    // },
    // auditorShops: {
    //     id: 'auditorShops',
    //     title: 'Auditor Shops',
    //     type: 'item',
    //     url: '/app/auditorShops',
    //     icon: 'feather icon-shopping-cart'
    // },
    // shareDashBoard: {
    //     id: 'shareDashBoard',
    //     title: 'Share DashBoard',
    //     type: 'item',
    //     url: '/app/shareDashBoard',
    //     icon: 'feather icon-shopping-cart'
    // },
    // qcShops: {
    //     id: 'qcShops',
    //     title: 'Qc Shops',
    //     type: 'item',
    //     url: '/app/qcShops',
    //     icon: 'feather icon-shopping-cart'
    // }
};

// const rolesMapping = {
//     qc: ['evaluation'],
//     super_admin: ['evaluation', 'report', 'roles', 'project', 'shops', 'period', 'task'],
//     user: ['report', 'project', 'shops', 'task'],
//     project_manager: ['evaluation', 'report', 'project', 'shops', 'period', 'task'],
//     qc_manager: ['evaluation', 'report', 'shops', 'period', 'task'],
//     auditor: [],
//     reporter: ['report']
// };

const getMenuItems = (userRole) => {
    let allowedScreens = [];
    if (userRole) {
        // console.log(userRole);
        const allowedActions = rolesMapping[userRole]?.allowedActions || [];

        allowedActions?.forEach((screenKey) => {
            if (!allowedScreens.includes(screenKey)) {
                allowedScreens.push(screenKey);
            }
        });
    }

    const menuItems = {
        items: [
            {
                id: 'elo',
                title: 'ELO',
                type: 'group',
                icon: 'icon-ui',
                children: allowedScreens.map((screenKey) => screens[screenKey])
            }
        ]
    };

    return menuItems;
};

export default getMenuItems;

// export default getMenuItems;
// const menuItems = {
//     items: [
//         {
//             id: 'audit',
//             title: 'Audit',
//             type: 'group',
//             icon: 'icon-ui',
//             children: []
//         }
//     ]
// };

// export default menuItems;

// {
//     id: 'ui-element',
//     title: 'UI ELEMENT',
//     type: 'group',
//     icon: 'icon-ui',
//     children: [
//         {
//             id: 'basic',
//             title: 'Components',
//             type: 'collapse',
//             icon: 'feather icon-box',
//             children: [
//                 {
//                     id: 'button',
//                     title: 'Button',
//                     type: 'item',
//                     url: '/basic/button'
//                 },
//                 {
//                     id: 'badges',
//                     title: 'Badges',
//                     type: 'item',
//                     url: '/basic/badges'
//                 },
//                 {
//                     id: 'breadcrumb',
//                     title: 'Breadcrumb',
//                     type: 'item',
//                     url: '/basic/breadcrumb'
//                 },
//                 {
//                     id: 'collapse',
//                     title: 'Collapse',
//                     type: 'item',
//                     url: '/basic/collapse'
//                 },
//                 {
//                     id: 'tabs-pills',
//                     title: 'Tabs & Pills',
//                     type: 'item',
//                     url: '/basic/tabs-pills'
//                 },
//                 {
//                     id: 'typography',
//                     title: 'Typography',
//                     type: 'item',
//                     url: '/basic/typography'
//                 }
//             ]
//         }
//     ]
// },
// {
//     id: 'ui-forms',
//     title: 'Forms & Tables',
//     type: 'group',
//     icon: 'icon-group',
//     children: [
//         {
//             id: 'forms',
//             title: 'Forms',
//             type: 'item',
//             url: '/forms/form-basic',
//             icon: 'feather icon-file-text'
//         },
//         {
//             id: 'bootstrap',
//             title: 'Bootstrap Table',
//             type: 'item',
//             url: '/tables/bootstrap',
//             icon: 'feather icon-server'
//         }
//     ]
// },
// {
//     id: 'chart-maps',
//     title: 'Chart & Maps',
//     type: 'group',
//     icon: 'icon-charts',
//     children: [
//         {
//             id: 'charts',
//             title: 'Charts',
//             type: 'item',
//             url: '/charts/nvd3',
//             icon: 'feather icon-pie-chart'
//         },
//         {
//             id: 'google-maps',
//             title: 'Google Maps',
//             type: 'item',
//             url: '/maps/google-map',
//             icon: 'feather icon-map'
//         },
//         {
//             id: 'leaflet-maps',
//             title: 'Leaflet Maps',
//             type: 'item',
//             url: '/maps/leaflet-map',
//             icon: 'feather icon-map'
//         }
//     ]
// },
// {
//     id: 'pages',
//     title: 'Pages',
//     type: 'group',
//     icon: 'icon-pages',
//     children: [
//         {
//             id: 'auth',
//             title: 'Authentication',
//             type: 'collapse',
//             icon: 'feather icon-lock',
//             children: [
//                 {
//                     id: 'signup-2',
//                     title: 'Sign UP (template)',
//                     type: 'item',
//                     url: '/auth/signup-2',
//                     target: true,
//                     breadcrumbs: false
//                 },
//                 {
//                     id: 'signin-2',
//                     title: 'Sign IN (template)',
//                     type: 'item',
//                     url: '/auth/signin-2',
//                     target: true,
//                     breadcrumbs: false
//                 }
//             ]
//         },
//         {
//             id: 'sample-page',
//             title: 'Sample Page',
//             type: 'item',
//             url: '/sample-page',
//             classes: 'nav-item',
//             icon: 'feather icon-sidebar'
//         }
//     ]
// },
// {
//     id: 'resources',
//     title: 'Resources',
//     type: 'group',
//     icon: 'icon-pages',
//     children: [
//         {
//             id: 'product-page',
//             title: 'Download Product',
//             type: 'item',
//             url: 'https://appseed.us/product/react-node-js-datta-able',
//             classes: 'nav-item',
//             icon: 'feather icon-download',
//             target: true,
//             external: true
//         },
//         {
//             id: 'support',
//             title: 'Get Support',
//             type: 'item',
//             icon: 'feather icon-help-circle',
//             classes: 'nav-item',
//             url: 'https://appseed.us',
//             target: true,
//             external: true
//         }
//     ]
// }
